<template>
    <section class="select-interior">
        <div class="configurator__container container">
            <StepBar step-name="Select your paint" :step="5" :steps="7" />

            <div class="configurator__flex-container">
                <div class="configurator__flex-left">
                    <Navigation :go-to-step="{ name: 'select-engine', params: { brand: brand, urlModel: urlModel }, query: { id: configuratorId } }" />

                    <ImageGallery />
                </div>

                <div class="configurator__flex-right">
                    <Card class="configurator__select-paint-card" :title="model.model_title" description="Choose your colour:" :price="vehiclePricePlusPaint" :is-small="true">
                        <LoadingSpinner v-if="loading"></LoadingSpinner>
                        <ColourRadioButton v-else v-model="selectedPaint" id-key="id" value-key="value" price-key="formattedPrice" :options="paints" :show-prices="true" />
                    </Card>

                    <div ref="continueButton" class="configurator__continue-btn-container">
                        <button class="btn btn--primary btn--min-width btn--full-width-xs" :class="{'btn--disabled': !paintChoice}" :disabled="!paintChoice" @click="nextStep">Continue</button>
                    </div>

                    <SaveConfiguration />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import ColourRadioButton from "../components/ColourRadioButton.vue";
import NumberFormat from "../../used-vue/api/NumberFormat";
import EventObject from "../../modules/tracking/EventObject";
import { mapState } from "vuex";

export default {
    props: {
        brand: {
            type: String,
            required: true,
        },
        urlModel: {
            type: String,
            required: true,
        },
    },
    components: {
        ColourRadioButton,
    },
    data() {
        return {
            loading: true,
        };
    },
    methods: {
        NumberFormat,
        nextStep() {
            if (!this.paintChoice) {
                return;
            }

            new EventObject("New Car - Configurator", "Next Step", "Clicked to Step 6 of 7: Select interior").dispatch();

            this.$router.push({
                name: "select-interior",
                params: { brand: this.brand, urlModel: this.urlModel },
                query: { id: this.configuratorId },
            });
        },
    },
    created() {
        this.$store.dispatch("getPaints").then(() => {
            document.title = `${this.model.model_title} ${this.engineChoice} | Configure My New ${this.manufacturer} Car`;

            this.$store.commit("setPaintChoice", this.paints[0].id);
            this.$store.commit("setSelectedPaintPrice", this.paints[0].price);
            this.$store.commit('updateFinanceRequests');

            if (this.paints.length == 1) {
                this.selectedPaint = this.paints[0].id;
            }

            this.loading = false;
        });
    },
    computed: {
        ...mapState(["model", "configuratorId", "availablePaints", "engineChoice", "manufacturer", "selectedVehiclePrice", "selectedPaintPrice", "paintChoice"]),

        paints() {
            return this.availablePaints.map((paint) => {
                return {
                    id: paint.id,
                    name: paint.name,
                    price: paint.price,
                    formattedPrice: this.NumberFormat(paint.price, 0),
                    primary_hex: paint.primary_hex,
                };
            });
        },

        selectedPaint: {
            get: function () {
                return this.$store.state.paintChoice;
            },
            set: function (selectedPaintId) {
                for (let index = 0; index < this.paints.length; index++) {
                    const selectedPaint = this.paints[index];
                    if (selectedPaint.id != selectedPaintId) {
                        continue;
                    }

                    this.$store.commit("setPaintChoice", selectedPaint.id);
                    this.$store.commit("setSelectedPaintPrice", selectedPaint.price);
                    this.$store.commit('updateFinanceRequests');

                    window.scrollTo(0, 0);
                    return;
                }
            },
        },

        vehiclePricePlusPaint() {
            return Number(this.selectedVehiclePrice) + Number(this.selectedPaintPrice);
        },
    },
};
</script>